module.exports = __webpack_public_path__ + "static/media/pin.cfc4da78.png";